<template>
  <div class="project-form">
    <div class="window-container">
      <div class="page-container">
        <v-layout
          justify-space-between
          wrap
        >
          <v-flex sm9>
            <v-layout
              justify-space-between
              wrap
            >
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  autocomplete="new-password"
                  outlined
                  hide-details
                  label="N° Patient"
                  :value="patient.patient_id"
                  readonly
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  outlined
                  hide-details
                  label="N° Appareil"
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  v-model="project.file_number"
                  autocomplete="new-password"
                  outlined
                  hide-details
                  label="N° Dossier"
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  v-model="patient.lastname"
                  v-validate="'required'"
                  autocomplete="new-password"
                  outlined
                  hide-details
                  label="Nom"
                  :error-messages="errors.collect('patientLastname')"
                  data-vv-name="patientLastname"
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  v-model="patient.firstname"
                  v-validate="'required'"
                  autocomplete="new-password"
                  outlined
                  hide-details
                  label="Prénom"
                  :error-messages="errors.collect('patientFirstname')"
                  data-vv-name="patientFirstname"
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-dialog
                  ref="datePicker_dob"
                  v-model="datePicker_dob"
                  :return-value.sync="patient.dob"
                  color="#880e4f"
                  width="290px"
                  persistent
                >
                  <template #activator="{ on }">
                    <v-text-field
                      label="Date de naissance"
                      :value="patient.dob | dateFormat"
                      readonly
                      hide-details
                      outlined
                      single-line
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="patient.dob"
                    first-day-of-week="1"
                    no-title
                    scrollable
                  >
                    <div class="flex-grow-1" />
                    <v-btn
                      text
                      color="#880e4f"
                      @click="datePicker_dob = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      text
                      color="#880e4f"
                      @click="$refs.datePicker_dob.save(patient.dob)"
                    >
                      Ok
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>

              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  v-model="patient.nir"
                  v-validate="'max:13'"
                  autocomplete="new-password"
                  outlined
                  label="N° de Sécu"
                  :error-messages="errors.collect('nir')"
                  data-vv-name="nir"
                />
              </v-flex>
              <v-flex
                sm4
                mb-5
              >
                <v-text-field
                  v-model="patient.nir_key"
                  autocomplete="new-password"
                  outlined
                  hide-details
                  label="Clé"
                />
              </v-flex>
              <v-flex
                sm4
                mb-2
              />
            </v-layout>
          </v-flex>
          <v-flex sm3>
            <v-radio-group
              v-model="project.project_method"
              v-validate="'required'"
              :error-messages="errors.collect('projectMethod')"
              data-vv-name="projectMethod"
              hide-details
            >
              <v-radio
                label="Essayage"
                value="FITTING"
              />
              <v-radio
                label="Préfinition"
                value="PREFINISHING"
              />
              <v-radio
                label="Livraison directe"
                value="DIRECT_DELIVERY"
              />
            </v-radio-group>
          </v-flex>
          <v-flex>
            <v-radio-group
              v-model="project.renew"
              v-validate="'required'"
              :error-messages="errors.collect('renew')"
              data-vv-name="renew"
              row
              hide-details
            >
              <v-radio
                label="Première installation"
                value="FIRST_INSTALLATION"
              />
              <v-radio
                label="Renouvellement"
                value="RENEW"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-tabs v-model="tab">
          <v-layout justify-space-around>
            <v-tab>Coordonnées</v-tab>
            <v-tab>Programmation</v-tab>
          </v-layout>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-layout
                justify-space-between
                wrap
              >
                <v-flex
                  sm5
                  mb-5
                >
                  <v-text-field
                    v-model="patient.address"
                    autocomplete="new-password"
                    autofill="off"
                    hide-details
                    outlined
                    label="Adresse"
                  />
                </v-flex>
                <v-flex
                  sm5
                  mb-5
                >
                  <v-text-field
                    v-model="patient.city"
                    autocomplete="new-password"
                    hide-details
                    outlined
                    label="Ville"
                  />
                </v-flex>
                <v-flex sm2>
                  <v-text-field
                    v-model="patient.zipcode"
                    autocomplete="new-password"
                    hide-details
                    outlined
                    label="CP"
                  />
                </v-flex>
                <v-flex
                  sm5
                  mb-5
                >
                  <v-text-field
                    v-model="patient.phone"
                    v-validate="'max:10'"
                    autocomplete="new-password"
                    outlined
                    label="Téléphone"
                    :error-messages="errors.collect('phone')"
                    data-vv-name="phone"
                  />
                </v-flex>
                <v-flex
                  sm5
                  mb-5
                >
                  <v-text-field
                    v-model="patient.cellular"
                    v-validate="'max:10'"
                    autocomplete="new-password"
                    outlined
                    label="Mobile"
                    :error-messages="errors.collect('cellular')"
                    data-vv-name="cellular"
                  />
                </v-flex>
                <v-flex sm2>
                  <v-btn disabled>
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout
                justify-space-between
                wrap
              >
                <v-flex
                  sm4
                  mb-5
                >
                  <v-dialog
                    ref="datePicker_fitting1_at"
                    v-model="datePicker_fitting1_at"
                    :return-value.sync="project.fitting1_at"
                    color="#880e4f"
                    width="290px"
                    persistent
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        :value="project.fitting1_at | dateFormat"
                        :disabled="isDirectDelivery"
                        label="Date Essayage 1"
                        class="mb-4"
                        hide-details
                        outlined
                        clearable
                        readonly
                        single-line
                        v-on="on"
                        @click:clear="project.fitting1_at = null"
                      />
                    </template>
                    <v-date-picker
                      v-model="project.fitting1_at"
                      first-day-of-week="1"
                      no-title
                      scrollable
                    >
                      <div class="flex-grow-1" />
                      <v-btn
                        text
                        color="#880e4f"
                        @click="datePicker_fitting1_at = false"
                      >
                        Annuler
                      </v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="
                          $refs.datePicker_fitting1_at.save(project.fitting1_at)
                        "
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex
                  sm4
                  mb-5
                >
                  <v-dialog
                    ref="datePicker_fitting2_at"
                    v-model="datePicker_fitting2_at"
                    :return-value.sync="project.fitting2_at"
                    color="#880e4f"
                    width="290px"
                    persistent
                    :disabled="
                      isDirectDelivery || isPrefinishing || !project.fitting1_at
                    "
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        :value="project.fitting2_at | dateFormat"
                        :disabled="
                          isDirectDelivery ||
                            isPrefinishing ||
                            !project.fitting1_at
                        "
                        label="Date Essayage 2"
                        class="mb-4"
                        single-line
                        readonly
                        clearable
                        hide-details
                        outlined
                        @click:clear="project.fitting2_at = null"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="project.fitting2_at"
                      first-day-of-week="1"
                      no-title
                      scrollable
                    >
                      <div class="flex-grow-1" />
                      <v-btn
                        text
                        color="#880e4f"
                        @click="datePicker_fitting2_at = false"
                      >
                        Annuler
                      </v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="
                          $refs.datePicker_fitting2_at.save(project.fitting2_at)
                        "
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex sm4>
                  <v-dialog
                    ref="datePicker_fitting3_at"
                    v-model="datePicker_fitting3_at"
                    :return-value.sync="project.fitting3_at"
                    color="#880e4f"
                    width="290px"
                    persistent
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        :value="project.fitting3_at | dateFormat"
                        :disabled="
                          isDirectDelivery ||
                            isPrefinishing ||
                            !project.fitting2_at
                        "
                        label="Date Essayage 3"
                        class="mb-4"
                        readonly
                        clearable
                        hide-details
                        outlined
                        single-line
                        @click:clear="project.fitting3_at = null"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="project.fitting3_at"
                      first-day-of-week="1"
                      no-title
                      scrollable
                    >
                      <div class="flex-grow-1" />
                      <v-btn
                        text
                        color="#880e4f"
                        @click="datePicker_fitting3_at = false"
                      >
                        Annuler
                      </v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="
                          $refs.datePicker_fitting3_at.save(project.fitting3_at)
                        "
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex
                  sm4
                  mb-5
                >
                  <v-dialog
                    ref="datePicker_planned_delivery_at"
                    v-model="datePicker_planned_delivery_at"
                    :return-value.sync="project.planned_delivery_at"
                    color="#880e4f"
                    width="290px"
                    persistent
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        :value="project.planned_delivery_at | dateFormat"
                        label="Livraison Prévue"
                        class="mb-4"
                        single-line
                        readonly
                        clearable
                        hide-details
                        outlined
                        @click:clear="project.planned_delivery_at = null"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="project.planned_delivery_at"
                      first-day-of-week="1"
                      no-title
                      scrollable
                    >
                      <div class="flex-grow-1" />
                      <v-btn
                        text
                        color="#880e4f"
                        @click="datePicker_planned_delivery_at = false"
                      >
                        Annuler
                      </v-btn>
                      <v-btn
                        text
                        color="#880e4f"
                        @click="
                          $refs.datePicker_planned_delivery_at.save(
                            project.planned_delivery_at
                          )
                        "
                      >
                        Ok
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex
                  sm4
                  mb-5
                >
                  <!--  real delivery -->
                  <v-text-field
                    :value="project.real_delivery_at | dateFormat"
                    label="Livraison Réelle"
                    class="mb-4"
                    readonly
                    disabled
                    hide-details
                    outlined
                  />
                </v-flex>
                <v-flex
                  sm4
                  mb-5
                >
                  <!-- Estimated maunfacturing delivery -->
                  <v-text-field
                    v-model="project.estimated_finishing_time_in_float"
                    type="number"
                    data-vv-name="estimatedTime"
                    label="Estimation Fabrication"
                    clearable
                    outlined
                    class="mb-4"
                  />
                  <!-- End DatePicker -->
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <v-layout
          mt-5
          justify-space-between
        >
          <v-flex sm7>
            <v-text-field
              v-model="project.center"
              v-validate="'max:50'"
              autocomplete="new-password"
              label="Centre"
              clearable
              outlined
              :error-messages="errors.collect('center')"
              data-vv-name="center"
            />
          </v-flex>
          <v-flex sm5>
            <v-layout justify-space-between>
              <v-flex sm4>
                <v-btn
                  block
                  disabled
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm4>
                <v-btn
                  block
                  disabled
                >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm4>
                <v-btn
                  block
                  disabled
                >
                  <v-icon>mdi-eraser</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          mt-5
          justify-space-between
        >
          <v-flex sm7>
            <v-select
              v-model="project.product_model"
              v-validate="'required'"
              filled
              :items="models"
              :error-messages="errors.collect('product')"
              data-vv-name="product"
              placeholder="Sélectionner un modèle de fiche"
            />
          </v-flex>
          <v-flex sm5>
            <v-btn
              block
              :disabled="disableProductBtn"
              @click="onProductClick"
            >
              Ouvrir fiche applicateur
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          mt-5
          justify-space-between
        >
          <v-flex sm6>
            <v-select
              v-model="project.applicator_id"
              v-validate="'required'"
              filled
              :items="usersItems"
              :error-messages="errors.collect('applicator')"
              data-vv-name="applicator"
              placeholder="Sélectionner un  applicateur"
              disabled
            />
          </v-flex>
          <v-flex sm6>
            <v-select
              v-model="project.applicator_supp_id"
              filled
              :items="usersItems"
              placeholder="Sélectionner un suppléant"
              clearable
            />
          </v-flex>
        </v-layout>
        <v-layout
          justify-space-between
          mb-4
        >
          <v-flex sm6>
            <v-textarea
              v-model="project.comment"
              filled
              name="Ajouter un commentaires :"
              label="Ajouter un commentaires :"
              value
              rows="3"
              hide-details
            />
          </v-flex>
          <v-flex sm6>
            <v-btn
              block
              :disabled="
                !isOnline || !!project.real_delivery_at || disableProductBtn
              "
              @click="onTransferClick"
            >
              <v-icon class="mr-2">
                mdi-send
              </v-icon>Transférer « appareil
              livré »
            </v-btn>
            <v-layout
              justify-space-between
              class="mt-3"
            >
              <v-flex sm6>
                <v-btn
                  block
                  :disabled="disableProductBtn"
                  @click="$emit('media-click')"
                >
                  <v-icon class="mr-2">
                    mdi-image-size-select-actual
                  </v-icon>Médias
                </v-btn>
              </v-flex>
              <v-flex sm6>
                <v-btn
                  block
                  disabled
                >
                  <v-icon class="mr-2">
                    mdi-content-duplicate
                  </v-icon>Dupliquer
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-space-between>
          <v-flex sm6>
            <v-switch
              v-model="project.idc_not_managed_workshop_manager"
              label="Non gérée chef atelier"
              hide-details
            />
            <v-switch
              v-model="project.transferable"
              label="Fiche transferable"
              hide-details
              class="mt-0"
            />
          </v-flex>
          <v-flex sm3>
            <v-checkbox
              disabled
              :input-value="project.real_delivery_at != null"
              hide-details
              label="Appareil livré"
              class="mr-4 mt-2"
            />
            <v-checkbox
              v-model="project.idc_finishing"
              :disabled="userRole !== 'CHIEF'"
              hide-details
              label="Finition lancement fabrication"
              class="mr-4 mt-2"
            />
          </v-flex>
          <v-flex sm3>
            <v-checkbox
              disabled
              hide-details
              label="Couture OK"
              class="mr-4 mt-2"
            />
            <v-checkbox
              v-model="project.idc_launch_test"
              :disabled="userRole !== 'CHIEF'"
              hide-details
              label="Essai lancement fabrication"
              class="mr-4 mt-2"
            />
          </v-flex>
        </v-layout>

        <v-row v-if="!disableProductBtn">
          <v-col class="text-right">
            <!-- <v-btn color="red">Supprimer</v-btn> -->
            <v-dialog
              v-model="deleteDialog"
              persistent
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Supprimer
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">
                  Voulez-vous supprimer cette fiche de votre tablette ?
                </v-card-title>
                <v-card-text>
                  Attention si vous supprimez la fiche, toutes les données de
                  celle-ci seront perdus.
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteDialog = false"
                  >
                    Annuler
                  </v-btn>
                  <v-btn
                    color="red"
                    text
                    @click="onDeleteClick"
                  >
                    Supprimer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="save-container">
      <v-btn
        class="cancel"
        @click="onCancel"
      >
        <v-icon>mdi-close</v-icon>Annuler
      </v-btn>
      <v-btn
        class="save"
        @click="onSubmit"
      >
        <v-icon>mdi-content-save</v-icon>Enregistrer
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectForm",

  props: {
    project: {
      type: Object,
      required: true
    },

    patient: {
      type: Object,
      required: true
    },

    disableProductBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tab: null,

      localProject: null,
      localPatient: null,
      localUsers: null,

      datePicker_fitting1_at: false,
      datePicker_fitting2_at: false,
      datePicker_fitting3_at: false,
      datePicker_planned_delivery_at: false,
      datePicker_real_delivery_at: false,
      datePicker_estimated_manufacturing_at: false,
      datePicker_dob: false,

      deleteDialog: false
    };
  },
  computed: {
    ...mapGetters({
      userRole: "auth/getLoggedInUserRole"
    }),

    usersItems() {
      if (this.localUsers) {
        return this.localUsers.map(user => {
          return {
            text: `${user.lastname} ${user.firstname}`,
            value: user.id
          };
        });
      }
      return null;
    },

    models() {
      return [
        {
          text: "Minerve",
          value: "NECK_BRACE"
        },
        {
          text: "Siège moulé",
          value: "MOLDED_SEAT"
        },
        {
          text: "Otn",
          value: "OTN"
        },
        {
          text: "Verticalisateur",
          value: "LIFT"
        },
        {
          text: "Retouche/Réparation",
          value: "RETOUCHING_REPAIR"
        },
        {
          text: "Selle",
          value: "SEAT"
        },
        {
          text: "Selle de positionnement",
          value: "POSITIONING_SEAT"
        },
        {
          text: "Othèse M sup",
          value: "UPPER_LIMB_ORTHOSIS"
        },
        {
          text: "Othèse M inf",
          value: "LOWER_LIMB_ORTHOSIS"
        },
        {
          text: "Corset",
          value: "CORSET"
        }
      ];
    },

    isFitting() {
      return this.project.project_method === "FITTING";
    },

    isPrefinishing() {
      return this.project.project_method === "PREFINISHING";
    },

    isDirectDelivery() {
      return this.project.project_method === "DIRECT_DELIVERY";
    }
  },

  async mounted() {
    this.localProject = this.project;
    this.localPatient = this.patient;

    this.localUsers = await this.getLocalUsers();
  },

  methods: {
    ...mapActions({
      getLocalUsers: "users/getLocalUsers"
    }),

    /**
     * Validate form and emit event
     */
    async onSubmit() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        const notification = {
          message: `Vérifiez le formulaire`,
          type: "error"
        };
        this.$store.dispatch("notifications/add", notification);
        return;
      }

      this.$emit("on-submit");
    },

    // Emit on-cancel on cancel
    onCancel() {
      this.$emit("on-cancel");
    },

    // Emit on-product-click
    onProductClick() {
      this.$emit("on-product-click");
    },

    // Emit on-transfer-click
    onTransferClick() {
      this.$emit("on-transfer-click");
    },

    onDeleteClick() {
      this.$emit("on-delete-click");
      this.deleteDialog = false;
    }
  }
};
</script>

<style lang="scss">
.project-form {
  margin: -12px;
  .v-input--selection-controls {
    margin-top: 0;
    padding: 0;
  }
  .v-tabs {
    .v-item-group {
      .v-tab {
        color: #006064;
        font-weight: 400;
        &.v-tab--active {
          color: #880e4f !important;
          &::before {
            color: #880e4f !important;
          }
        }
      }
      .v-tabs-slider {
        background-color: #880e4f !important;
      }
    }
  }
  .v-window {
    border-top: 1px solid rgba(#d4d4d5, 0.5);
    border-bottom: 1px solid rgba(#d4d4d5, 0.5);
    padding-top: 15px;
  }
  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px 45px;
    .v-btn.blue-stone {
      background-color: #006064 !important;
      color: white !important;
    }
  }
  .page-container {
    > div {
      &:first-child {
        z-index: 999;
        position: relative;
      }
    }
  }
}
</style>
